import api from 'api'

export type DeleteCustomShiftNotificationParams = {
  shiftId: number
  notificationId: number
}

export async function deleteCustomShiftNotification({
  shiftId,
  notificationId,
}: DeleteCustomShiftNotificationParams) {
  const response = await api.delete(
    `/admin/shift/${shiftId}/custom_notifications/${notificationId}`
  )
  return response.data
}
